// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button.logo{background:none;border:none;outline:none}`, "",{"version":3,"sources":["webpack://./src/components/layouts/RipLayout.scss"],"names":[],"mappings":"AAAA,YACE,eAAA,CACA,WAAA,CACA,YAAA","sourcesContent":["button.logo {\n  background: none;\n  border: none;\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
